// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.component-table-header-buttons__actions { 
    width: 100%;
    display: flex;
    justify-content: flex-start;
    grid-area: 1 / 1 / 1 / 6;
    align-items: center;
}

.component-table-header-buttons__actions .component-table-header-buttons__actions__title {
    margin-right: var( --space-and-half );
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: var( --font-medium );
    font-size: calc( var( --space ) + var( --space-quarter ) );
    line-height: var( --space-and-half );
    color: var( --primary-dark-color );
}

.component-table-header-buttons__actions__title.only-title{
    margin: 20px 0;
}

/* .component-table-header-buttons__actions-add input[type=text] {
    border: 1px solid var(--basic-gray-color);
    float: left;
    max-height: var(--space-x2);
    background: var(--white-color);
    padding: var(--space) var(--space-and-half);
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
} */

.component-table-header-buttons__actions__message {
    padding: 0px var(--space);
    position: relative;
    background-color: var(--primary-dark-color);
    color: var(--white-color);
    font-family: var(--secondary-font);
    font-size: var(--font-small);
    font-weight: var(--font-bold);
    line-height: var(--space);
    text-align: center;
    letter-spacing: 0.004em;
    border-radius: var(--space-and-half);
    display: flex;
    top: 48px;
    width: calc(var(--space-x3) * 3);
    right: 120px;
    height: 48px;
    align-items: center;
    
}
.component-table-header-buttons__actions_grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 0px 0px;
    padding-bottom: var(--space-half);;
    /*grid-template-areas:
    "search add add add";*/
    align-items: center;
}
  
.component-table-header-buttons__actions-search { 
    /*grid-area: serach; */
    grid-area: 1 / 1 / 1 / 4;
}

/* .component-table-header-search-form__form  input[type=text] {        
    float: left;
    max-height: var(--space-x2);
    background: var(--white-color);
}
.component-table-header-search-form__form  input[type=text]:focus-within{
    border: 3px solid var(--primary-very-dark-color);
}

.component-table-header-search-form__form svg { 
    position: absolute; 
}  */
  
.component-table-header-search-form__form .seacrh-icon { 
    fill: var(--basic-gray-color) !important;
    padding: var(--space-half); 
    min-width: 40px; 
    margin-left: -50px;
    /*font-size: var(--space) !important;*/
    font-size: 2.5rem !important;
} 

.component-table-header-search-form__form button {
    float: left;
    width: 20%;    
    background: var(--white-color);
    color: var(--primary-very-dark-color);    
    border: none;    
    box-shadow: none;
    cursor: pointer;
}

.component-table-header-search-form__form button:hover {
    background: var(--white-color);
    box-shadow: none;
}

.component-table-header-buttons__list {
    padding-top: var(--space);
    display: flex;
    align-items: center;
}

.component-table-header-buttons__add{
    margin: 0 calc( var( --space ) - var( --space-eighth ) );
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-column-gap: var(--space-and-half);
    column-gap: var(--space-half);
    grid-row-gap: var(--space-half);
    row-gap: var(--space-half);
    align-items: center;
}

.component-table-header-buttons__add-optional{
    grid-area: 1/2/1/4;
    justify-content: flex-end;
    display: flex;
}

.component-table-header-button__list {
    border: 1px solid var(--basic-gray-color);
    display: flex;    
    align-items: center;
    border-radius: 25px;
    box-sizing: border-box;
    justify-content: center;
    padding: var(--space-half) var(--space); 
    height: calc( var( --space-x2 ) - var( --space-eighth ) );
    background-color: var( --white-color );
    color: var( --basic-gray-color );
    margin-right: var( --space-half-quarter );
}

.component-table-header-button-button.baloa-table-column {
    border-radius: calc( var( --space ) + var( --space-quarter ) );
    padding: calc( var( --space-half ) - 1px ) var( --space-and-half );
    font-size: calc( var( --space ) - var( --space-eighth ) );
    line-height: calc( var( --space ) + 1px );
    color: var( --white-color );
    /* color: var( --white-color );
    background-color: var( --new-green-color );
    font-family: var( --secondary-font );
    font-size: calc( var( --space ) - var( --space-quarter ) );
    font-weight: var( --font-medium );
    line-height: var( --space );
    align-items: center;
    letter-spacing: 0.0025em;
    height: var( --space-x2 );
    display: flex;
    justify-content: center;
    border-radius: calc( var( --space ) + var( --space-quarter ) );
    padding: var( --space-half ) var( --space-and-half ); */
}

.component-table-header-button-button span {
    text-transform: capitalize;
}

.component-table-header-buttons__button-fixture{
    margin-left: auto;
    margin-top: var( --space );
    margin-bottom: calc( var( --space ) - var( --space-eighth ) );
}

.component-table-header-button__list:focus {
    /* background-color: var(--focused-sb-bg-color); */
    cursor: pointer;
    /* background-color: var(--hover-sb-bg-color); */
}
.component-table-header-button__list:hover {
    cursor: pointer;    
}
.component-table-header-button__list:active {
    cursor: pointer;
    /* background-color: var(--active-sb-bg-color); */
}
.component-table-header-button__list .baloa-table {
    color: var( --basic-gray-color );
}

.component-table-header-button__list img {
    width: var(--space);
    height: var(--space);
}
.component-table-header-button__list_selected, .component-table-header-button__list:hover {
    border-radius: 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--space-half) var(--space); 
    height: calc( var( --space-x2 ) - var( --space-eighth ) );
    background-color: #EAF7F0;
    color: var( --new-green-color );
    margin-right: var( --space-half-quarter );
    border: 1px solid var(--new-green-color);
}
.component-table-header-button__list_selected:focus {
    /* background-color: var(--focused-sb-bg-color); */
    cursor: pointer;
    /* background-color: var(--hover-sb-bg-color); */
}
.component-table-header-button__list_selected:hover {
    cursor: pointer;
    /* background-color: var(--hover-sb-bg-color); */
}
.component-table-header-button__list_selected:active {
    /* background-color: var(--active-sb-bg-color); */
    cursor: pointer;
}
.component-table-header-button__list_selected .baloa-table, .component-table-header-button__list:hover .baloa-table {
    color: var( --new-green-color );
}
.component-table-header-button__list_selected img {
    width: var(--space);
    height: var(--space);
}

.component-table-header-title {
    margin-bottom: 0px !important;
}
  
.component-table-header-buttons__filter-buttons {
    grid-area: 2 / 1 / 2 / 4;
    justify-content: flex-start;
    margin: 0 calc( var( --space ) - var( --space-eighth ) );
    align-items: center;
    display: flex;
}

.table-header-buttons-action__separator {
    height: 0;
    border: var( --space-eighth ) solid var( --new-input-background-color );
    background-color: var( --new-input-background-color );
}
  
`, "",{"version":3,"sources":["webpack://./src/shared/components/dynamic-table/TableHeaderButtonsActionsComponent.styles.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,kBAAkB;IAClB,iCAAiC;IACjC,0DAA0D;IAC1D,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;IACI,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;IAC3C,yBAAyB;IACzB,kCAAkC;IAClC,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,oCAAoC;IACpC,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,mBAAmB;;AAEvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,YAAY;IACZ,iCAAiC;IACjC;0BACsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;;;;;;;;;;;IAWI;;AAEJ;IACI,wCAAwC;IACxC,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,UAAU;IACV,8BAA8B;IAC9B,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wDAAwD;IACxD,aAAa;IACb,0CAA0C;IAC1C,sCAAsC;IACtC,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,uCAAuC;IACvC,yDAAyD;IACzD,sCAAsC;IACtC,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI,8DAA8D;IAC9D,kEAAkE;IAClE,yDAAyD;IACzD,yCAAyC;IACzC,2BAA2B;IAC3B;;;;;;;;;;;;2DAYuD;AAC3D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,6DAA6D;AACjE;;AAEA;IACI,kDAAkD;IAClD,eAAe;IACf,gDAAgD;AACpD;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,iDAAiD;AACrD;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,yDAAyD;IACzD,yBAAyB;IACzB,+BAA+B;IAC/B,yCAAyC;IACzC,wCAAwC;AAC5C;AACA;IACI,kDAAkD;IAClD,eAAe;IACf,gDAAgD;AACpD;AACA;IACI,eAAe;IACf,gDAAgD;AACpD;AACA;IACI,iDAAiD;IACjD,eAAe;AACnB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,wDAAwD;IACxD,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,uEAAuE;IACvE,qDAAqD;AACzD","sourcesContent":["\n.component-table-header-buttons__actions { \n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    grid-area: 1 / 1 / 1 / 6;\n    align-items: center;\n}\n\n.component-table-header-buttons__actions .component-table-header-buttons__actions__title {\n    margin-right: var( --space-and-half );\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: var( --font-medium );\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n    line-height: var( --space-and-half );\n    color: var( --primary-dark-color );\n}\n\n.component-table-header-buttons__actions__title.only-title{\n    margin: 20px 0;\n}\n\n/* .component-table-header-buttons__actions-add input[type=text] {\n    border: 1px solid var(--basic-gray-color);\n    float: left;\n    max-height: var(--space-x2);\n    background: var(--white-color);\n    padding: var(--space) var(--space-and-half);\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n} */\n\n.component-table-header-buttons__actions__message {\n    padding: 0px var(--space);\n    position: relative;\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n    font-family: var(--secondary-font);\n    font-size: var(--font-small);\n    font-weight: var(--font-bold);\n    line-height: var(--space);\n    text-align: center;\n    letter-spacing: 0.004em;\n    border-radius: var(--space-and-half);\n    display: flex;\n    top: 48px;\n    width: calc(var(--space-x3) * 3);\n    right: 120px;\n    height: 48px;\n    align-items: center;\n    \n}\n.component-table-header-buttons__actions_grid-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    gap: 0px 0px;\n    padding-bottom: var(--space-half);;\n    /*grid-template-areas:\n    \"search add add add\";*/\n    align-items: center;\n}\n  \n.component-table-header-buttons__actions-search { \n    /*grid-area: serach; */\n    grid-area: 1 / 1 / 1 / 4;\n}\n\n/* .component-table-header-search-form__form  input[type=text] {        \n    float: left;\n    max-height: var(--space-x2);\n    background: var(--white-color);\n}\n.component-table-header-search-form__form  input[type=text]:focus-within{\n    border: 3px solid var(--primary-very-dark-color);\n}\n\n.component-table-header-search-form__form svg { \n    position: absolute; \n}  */\n  \n.component-table-header-search-form__form .seacrh-icon { \n    fill: var(--basic-gray-color) !important;\n    padding: var(--space-half); \n    min-width: 40px; \n    margin-left: -50px;\n    /*font-size: var(--space) !important;*/\n    font-size: 2.5rem !important;\n} \n\n.component-table-header-search-form__form button {\n    float: left;\n    width: 20%;    \n    background: var(--white-color);\n    color: var(--primary-very-dark-color);    \n    border: none;    \n    box-shadow: none;\n    cursor: pointer;\n}\n\n.component-table-header-search-form__form button:hover {\n    background: var(--white-color);\n    box-shadow: none;\n}\n\n.component-table-header-buttons__list {\n    padding-top: var(--space);\n    display: flex;\n    align-items: center;\n}\n\n.component-table-header-buttons__add{\n    margin: 0 calc( var( --space ) - var( --space-eighth ) );\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    grid-column-gap: var(--space-and-half);\n    column-gap: var(--space-half);\n    grid-row-gap: var(--space-half);\n    row-gap: var(--space-half);\n    align-items: center;\n}\n\n.component-table-header-buttons__add-optional{\n    grid-area: 1/2/1/4;\n    justify-content: flex-end;\n    display: flex;\n}\n\n.component-table-header-button__list {\n    border: 1px solid var(--basic-gray-color);\n    display: flex;    \n    align-items: center;\n    border-radius: 25px;\n    box-sizing: border-box;\n    justify-content: center;\n    padding: var(--space-half) var(--space); \n    height: calc( var( --space-x2 ) - var( --space-eighth ) );\n    background-color: var( --white-color );\n    color: var( --basic-gray-color );\n    margin-right: var( --space-half-quarter );\n}\n\n.component-table-header-button-button.baloa-table-column {\n    border-radius: calc( var( --space ) + var( --space-quarter ) );\n    padding: calc( var( --space-half ) - 1px ) var( --space-and-half );\n    font-size: calc( var( --space ) - var( --space-eighth ) );\n    line-height: calc( var( --space ) + 1px );\n    color: var( --white-color );\n    /* color: var( --white-color );\n    background-color: var( --new-green-color );\n    font-family: var( --secondary-font );\n    font-size: calc( var( --space ) - var( --space-quarter ) );\n    font-weight: var( --font-medium );\n    line-height: var( --space );\n    align-items: center;\n    letter-spacing: 0.0025em;\n    height: var( --space-x2 );\n    display: flex;\n    justify-content: center;\n    border-radius: calc( var( --space ) + var( --space-quarter ) );\n    padding: var( --space-half ) var( --space-and-half ); */\n}\n\n.component-table-header-button-button span {\n    text-transform: capitalize;\n}\n\n.component-table-header-buttons__button-fixture{\n    margin-left: auto;\n    margin-top: var( --space );\n    margin-bottom: calc( var( --space ) - var( --space-eighth ) );\n}\n\n.component-table-header-button__list:focus {\n    /* background-color: var(--focused-sb-bg-color); */\n    cursor: pointer;\n    /* background-color: var(--hover-sb-bg-color); */\n}\n.component-table-header-button__list:hover {\n    cursor: pointer;    \n}\n.component-table-header-button__list:active {\n    cursor: pointer;\n    /* background-color: var(--active-sb-bg-color); */\n}\n.component-table-header-button__list .baloa-table {\n    color: var( --basic-gray-color );\n}\n\n.component-table-header-button__list img {\n    width: var(--space);\n    height: var(--space);\n}\n.component-table-header-button__list_selected, .component-table-header-button__list:hover {\n    border-radius: 25px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: var(--space-half) var(--space); \n    height: calc( var( --space-x2 ) - var( --space-eighth ) );\n    background-color: #EAF7F0;\n    color: var( --new-green-color );\n    margin-right: var( --space-half-quarter );\n    border: 1px solid var(--new-green-color);\n}\n.component-table-header-button__list_selected:focus {\n    /* background-color: var(--focused-sb-bg-color); */\n    cursor: pointer;\n    /* background-color: var(--hover-sb-bg-color); */\n}\n.component-table-header-button__list_selected:hover {\n    cursor: pointer;\n    /* background-color: var(--hover-sb-bg-color); */\n}\n.component-table-header-button__list_selected:active {\n    /* background-color: var(--active-sb-bg-color); */\n    cursor: pointer;\n}\n.component-table-header-button__list_selected .baloa-table, .component-table-header-button__list:hover .baloa-table {\n    color: var( --new-green-color );\n}\n.component-table-header-button__list_selected img {\n    width: var(--space);\n    height: var(--space);\n}\n\n.component-table-header-title {\n    margin-bottom: 0px !important;\n}\n  \n.component-table-header-buttons__filter-buttons {\n    grid-area: 2 / 1 / 2 / 4;\n    justify-content: flex-start;\n    margin: 0 calc( var( --space ) - var( --space-eighth ) );\n    align-items: center;\n    display: flex;\n}\n\n.table-header-buttons-action__separator {\n    height: 0;\n    border: var( --space-eighth ) solid var( --new-input-background-color );\n    background-color: var( --new-input-background-color );\n}\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
